import {
  addDoc,
  collection,
  doc,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";
import { db } from "@poseidon/firebase/firebase";
import config from "@poseidon/utils/config";

const { collections } = config;

export const createDealer = async ({
  companyNumber,
  companyName,
  contactName,
  email,
  contactNumber,
  address1,
  address2,
  city,
  postcode,
}) =>
  await setDoc(doc(db, "dealers", companyNumber), {
    companyName,
    contactName,
    email,
    contactNumber,
    address1,
    address2,
    city,
    postcode,
    createdAt: serverTimestamp(),
  });

export const updateDealer = async (dealerId, values) =>
  await setDoc(
    doc(db, "dealers", dealerId),
    {
      ...values,
      updatedAt: new Date(),
    },
    { merge: true }
  );

export const updateDealerRiskProfile = async ({ dealerId, values }) =>
  await setDoc(
    doc(db, "dealerRiskProfiles", dealerId),
    {
      ...values,
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );

export async function addNote({ title, body, user, dealer, noteCategory }) {
  const values = {
    title,
    body,
    postedBy: doc(db, "admins", user.uid),
    createdAt: serverTimestamp(),
  };

  await addDoc(
    collection(db, collections.DealerRiskProfile, dealer.id, noteCategory),
    values
  );
}
